export const isProd = process.env.VUE_APP_ENV === "prod";
export const isDev = process.env.VUE_APP_ENV === "dev";

export const API_SCOPE = isProd ?
    "api://d96e5ec6-6d06-432c-9991-a7be015ac83f/Readwrite"
    : isDev
        ? "api://0c82f085-ee39-4a55-8340-9484a6605b1d/Readwrite"
        : "api://0c82f085-ee39-4a55-8340-9484a6605b1d/Readwrite";

export const LOGIN_REQUEST_SCOPES = {
    scopes: ["User.Read"],
    extraScopesToConsent: [API_SCOPE]
};

export const AV_REQUEST_SCOPES = {
    scopes: [API_SCOPE]
}

export const SILENT_TOKEN_REFRESH_SCOPES = (currentAccount) => ({
    scopes: ["User.Read"],
    account: currentAccount,
    forceRefresh: false,
});

export const AV_SILENT_TOKEN_REFRESH_SCOPES = (currentAccount) => ({
    scopes: [API_SCOPE],
    account: currentAccount,
    forceRefresh: false,
})

export const Tenant = "05d75c05-fa1a-42e7-9cf1-eb416c396f2d";


export const CLIENT_ID = isProd ?
    "d96e5ec6-6d06-432c-9991-a7be015ac83f"
    : isDev
        ? "0c82f085-ee39-4a55-8340-9484a6605b1d"
        : "0c82f085-ee39-4a55-8340-9484a6605b1d";

export const Redirect_Uri = isProd ?
    "https://pipelinerecommendation.maersk-digital.net/"
    : isDev
        ? "https://gdacustrecuidev-cdt.maersk.io/"
        : "http://localhost:8081";

export const Graph_Api_Base = "https://graph.windows.net";

export const Graph_Api_Resource = "00000002-0000-0000-c000-000000000000";

export const Msal_Config = {
    auth: {
        clientId: CLIENT_ID,
        authority: `https://login.microsoftonline.com/${Tenant}/`,
        requireAuthOnInitialize: true,
        autoRefreshToken: true,
        redirectUri: Redirect_Uri,
        postLogoutRedirectUri: Redirect_Uri,
    },
    request: {
        scopes: ["User.Read"],
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true,
    },
    graph: {
        callAfterInit: false,
    },
};
